import { render, staticRenderFns } from "./Courtesy.vue?vue&type=template&id=2b85649c&scoped=true&"
import script from "./Courtesy.vue?vue&type=script&lang=js&"
export * from "./Courtesy.vue?vue&type=script&lang=js&"
import style0 from "./Courtesy.vue?vue&type=style&index=0&id=2b85649c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85649c",
  null
  
)

export default component.exports